import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addCategoryAPI,
  viewCategory,
  editCategoryAPI,
  deleteCategoryAPI,
  viewCategorysApi,
} from "../Apis/category";

const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
};

export const addCategory = createAsyncThunk(
  "category/register",
  async ({ category }, { rejectWithValue }) => {
    try {
      const response = await addCategoryAPI(category);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Category add failed");
    }
  }
);

export const editCategory = createAsyncThunk(
  "category/update",
  async ({ id, category }, { rejectWithValue }) => {
    try {
      const response = await editCategoryAPI(id, category);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Category Edit failed");
    }
  }
);
export const deleteCategory = createAsyncThunk(
  "category/delete",
  async ({ id }, { rejectWithValue, dispatch }) => {
    try {
      const response = await deleteCategoryAPI(id);

      dispatch(fetchCategory({ page: 1, pageSize: 10 }));

      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Category Delete failed");
    }
  }
);
// Async thunk to fetch gallery data
export const fetchCategory = createAsyncThunk(
  "category/view",
  async ({ page, pageSize }, { rejectWithValue }) => {
    try {
      const response = await viewCategory(page, pageSize);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch data");
    }
  }
);
// Async thunk to fetch gallery data
export const viewCategorys = createAsyncThunk(
  "category/viewCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await viewCategorysApi();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch data");
    }
  }
);

const gallerySlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle media upload and gallery addition
      .addCase(addCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryData?.unshift(action.payload);
        state.totalRecords += 1;

        if (state.totalRecords % state.pageSize === 0) {
          state.totalPages += 1;
        }
      })
      .addCase(addCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      //edit
      .addCase(editCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.fetchAgain = true;
        state.error = null;
        // state.categoryData.unshift(action.payload);
      })
      .addCase(editCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      //delete
      .addCase(deleteCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })

      // Handle fetching gallery data
      .addCase(fetchCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategory.fulfilled, (state, action) => {
        state.loading = false;

        state.categoryData = action.payload?.data;
        state.totalRecords = action.payload?.totalRecords;
        state.totalPages = action.payload?.totalPages;
        state.currentPage = action.payload?.currentPage;
        state.pageSize = action.payload?.pageSize;
      })
      .addCase(fetchCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // viewallCategory
      .addCase(viewCategorys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewCategorys.fulfilled, (state, action) => {
        state.loading = false;
        state.categoriesData = action.payload?.data;
      })
      .addCase(viewCategorys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default gallerySlice.reducer;
